import actionTypes from "actions/actionTypes";

const initialState = {
  open: false,
  calls: 0
};

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_LOADER:
      return {
        ...state,
        open: true,
        calls: state.calls + 1
      };
    case actionTypes.HIDE_LOADER:
      const updatedCalls = state.calls - 1;
      return {
        ...state,
        open: updatedCalls === 0 ? false : true,
        calls: updatedCalls
      };
    default:
      return state;
  }
};

export default loaderReducer;
